'use client'

import { useCallback } from 'react'

export function CookiePreferencesButton() {
	const handleClick = useCallback(() => {
		window.dispatchEvent(new CustomEvent('cookie-consent-reopen'))
	}, [])

	return (
		<button type="button" onClick={handleClick} className="hover:text-foreground transition-colors">
			Cookie Preferences
		</button>
	)
}
